import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})

export class StorageService {

  signOut() {
    localStorage.removeItem(environment.accessTokenKey);
    localStorage.removeItem(environment.refreshTokenKey);
  }

  saveAccessToken(token: string) {
    localStorage.setItem(environment.accessTokenKey, token);
  }

  saveRefreshToken(token: string) {
    localStorage.setItem(environment.refreshTokenKey, token);
  }

  getAccessToken(): string | null {
    return localStorage.getItem(environment.accessTokenKey);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(environment.refreshTokenKey);
  }

  clearStorage() {
    this.signOut();
  }

}
